<template>
  <div class="w-full overflow-y-auto">
    <div class="w-full max-w-[1160px] min-w-[463px] pt-[36px] px-[32px] flex flex-col mx-auto min-h-[100vh]">
      <!-- Header -->
      <div class="flex flex-col mb-[16px]">
        <div class="flex items-center gap-[8px] mb-[4px]">
          <IconArrowLeft class="cursor-pointer" @click="$router.push('/remote-monitoring/kzs')" />
          <span class="text-[#212529] text-[20px] font-[500] leading-[120%]">{{ kzsData?.name || 'Клинически-значимое событие' }}</span>
        </div>

        <div class="text-[#6C757D] text-[16px] font-[400] leading-[150%]">Клинически-значимые события</div>
      </div>
      <!-- End Header -->
      <!-- Content -->
      <VSkeleton v-if="isLoading" class="w-full h-[380px] rounded-[8px]"/>
      <div v-else-if="isError" class="flex-1 min-h-0 flex">
          <v-placeholder
            message="Что-то пошло не так"
            description="Попробуйте повторить запрос <br> или обратитесь в службу поддержки"
            :icon="{ name: 'xl/mood-confuzed' }"
            :retry="{ label: 'Повторить запрос', handler: fetchNosologyList }"
            class="!min-h-[692px] h-full w-full !p-[24px]"
          >
            <template #footer>
              <p class="text-14-reg-400">Позвонить в техподдержку</p>
              <a
                class="text-v-ui-text-main text-14-reg-400 mt-[8px]"
                href="tel:88005000299"
                >8 800 500-02-99</a
              >
            </template>
          </v-placeholder>
      </div>

      <div v-else class="flex flex-col gap-[24px] pb-[50px]">
        <KzsViewCommonSettings :kzsData="kzsData" />
        <KzsViewAlgoSettings :kzsData="kzsData" />
        <KzsViewAdditionalSettings :kzsData="kzsData" />
      </div>
    </div>
  </div>
</template>

<script>
import kzsService from '@/services/kzs/kzs.service';
import IconArrowLeft from '@/assets/images/icon-left.svg';

import { VSkeleton, VPlaceholder } from '@gostelemed.front/rt-doctis.designsystem';

import KzsViewCommonSettings from '@/components/Kzs/KzsItems/KzsViewParts/KzsViewCommonSettings.vue';
import KzsViewAdditionalSettings from '@/components/Kzs/KzsItems/KzsViewParts/KzsViewAdditionalSettings.vue';
import KzsViewAlgoSettings from '@/components/Kzs/KzsItems/KzsViewParts/KzsViewAlgoSettings.vue';

export default {
  name: 'KzsView',
  page: {
    title: 'CRM Doctis - Клинически-значимые события',
  },
  components: {
    IconArrowLeft,
    VSkeleton,
    VPlaceholder,
    KzsViewCommonSettings,
    KzsViewAdditionalSettings,
    KzsViewAlgoSettings,
  },

  data() {
    return {
      isLoading: true,
      isError: false,
      kzsData: null,
    };
  },

  async mounted() {
    try {
      await this.fetchKzs();
    } catch (error) {
      this.isError = true;
      console.error(error);
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    // Запрос КЗС
    async fetchKzs() {
      try {
        this.kzsData = await kzsService.getKzs(this.$route.params.id);
      } catch (error) {
        if (error?.response?.status === 404) {
          this.$router.push('/remote-monitoring/kzs');
          return;
        }

        throw error;
      }
    },
  },

}
</script>
